export const IS_NEED_REDIRECT_TO_SOURCE_FROM_KEY = 'IS_NEED_REDIRECT_TO_SOURCE_FROM';
export const INACTIVE_STATUS_VALUE = 'INACTIVE_STATUS';
export const ACTIVE_STATUS_VALUE = 'ACTIVE_STATUS';
export const CURRENT_POINT_KEY = 'CURRENT_POINT';
export const IS_NEED_SHOW_LICENSES_MODAL = 'IS_NEED_SHOW_LICENSES_MODAL';
export const IS_NEED_SHOW_UNPAID_LICENSES_MODAL = 'IS_NEED_SHOW_UNPAID_LICENSES_MODAL';
export const ONBOARDING_FLOW = 'ONBOARDING_FLOW';

export const BILLING_PAGE_UNLOADED = 'BILLING_PAGE_UNLOADED';
export const BILLING_SESSION_KEY = 'BILLING_SESSION_DATA';

export const WRONG_PAYMENT_KIND_ERROR = /Неверный тип оплаты/;
